import axios from "axios";

import { LMS_BASE_URL } from "../../../../../utils/http/http-common";
import { LMS_TOKEN } from "../../../../../utils/cookiesmanager";

export const getInclusiveEducationContentApiCall = async (args) => {
  const { chapterId = 1, moduleId = 1, courseId = 1, languageId = 1 } = args;


  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/chapter/content?chapterId=${chapterId}&moduleId=${moduleId}&courseId=${courseId}&languageId=${languageId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};

export const savePreAssessment = async (payload) => {
  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.post(
      `${LMS_BASE_URL}/course/pre-assessment`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};
